import { Search, LogOut, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/hooks/useAuth';
import { useLayout } from './Layout';
import { useCommandPalette } from '@/components/CommandPalette';

export default function Header() {
  const { user, signOut } = useAuthStore();
  const { setSidebarOpen } = useLayout();
  const { open } = useCommandPalette();
  const isAdmin = user?.role === 'admin';
  // Rolle „vertrieb" (06.09.2026): Startseite ist die Betriebe-Liste, nicht die Kunden-Anfragen.
  const isVertrieb = user?.role === 'vertrieb';

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-200 z-50">
      <div className="h-full px-3 lg:px-4 flex items-center gap-3">
        <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg" aria-label="Menü">
          <Menu className="w-5 h-5" />
        </button>

        <Link to={isAdmin ? '/leitwarte' : isVertrieb ? '/betriebe' : '/leads'} className="flex items-center gap-2.5 w-[calc(14rem-0.75rem)]">
          <div className="w-7 h-7 bg-gray-900 rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-[11px] tracking-wide">NE</span>
          </div>
          <span className="text-gray-900 font-semibold text-sm hidden sm:block">Lead-Management</span>
        </Link>

        {/* Suche — die zentrale Navigation */}
        <button onClick={open} className="flex items-center gap-2 flex-1 max-w-md h-8 px-3 rounded-lg bg-gray-100 text-[13px] text-gray-400 hover:bg-gray-200/70 transition">
          <Search className="w-4 h-4" />
          <span className="flex-1 text-left truncate">{isAdmin ? 'Kunde, Seite oder Aktion suchen…' : 'Seite suchen…'}</span>
          <kbd className="hidden sm:inline text-[10px] text-gray-400 border border-gray-300 rounded px-1">⌘K</kbd>
        </button>

        <div className="ml-auto flex items-center gap-2">
          <div className="hidden sm:block text-right leading-tight">
            <p className="text-[13px] text-gray-900 font-medium">{user?.email?.split('@')[0] || 'Admin'}</p>
            <p className="text-[11px] text-gray-500">{isAdmin ? 'Administrator' : isVertrieb ? 'Vertrieb' : 'Kunde'}</p>
          </div>
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center border border-gray-200">
            <span className="text-gray-700 text-xs font-semibold">{(user?.email || 'A').charAt(0).toUpperCase()}</span>
          </div>
          <button onClick={() => signOut()} className="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg" title="Ausloggen">
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
